import vcAutocomplete from './Autocomplete'

module.exports = vcAutocomplete



// WEBPACK FOOTER //
// ./src/main.js